import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import FMPHeadline from '../../components/ui/FMPHeadline';
import Button from '@material-ui/core/Button';
import Search from '@material-ui/icons/Search';
import StationInvoicesContainer from '../../containers/accounting/StationInvoices';
import BulkInvoicesContainer from '../../containers/accounting/BulkInvoices';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
import SuppliersContainer from '../../containers/logistics/Suppliers';

import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPSelect from '../../components/pureForm/FMPSelect';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';

import FMPBulkCustomerMultiSelect from '../../components/pureForm/FMPBulkCustomerMultiSelect';
import FMPCarrierMultiSelect from '../../components/pureForm/FMPCarrierMultiSelect';
import FMPTerminalMultiSelect from '../../components/pureForm/FMPTerminalMultiSelect';
import FMPSupplierMultiSelect from '../../components/pureForm/FMPSupplierMultiSelect';
import FMPText from '../../components/pureForm/FMPText';
import { valueToDisplay } from '../../libs/products';
import { getLegs as getDeliveryLegs } from '../../libs/deliveryLegs';

import { invoiceStatusClassNames } from '../accounting/general';
import invoiceIcon from '../../images/invoicePdf.svg';
import quickbooksLogo from '../../images/quickbooksLogo.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormComponent from '../../components/FormComponent';
import { post } from '../../modules/utility';
// import {showErrors} from "../../modules/general";
import OpenLink from '@material-ui/icons/OpenInNew';
// import PopOver from "../../components/ui/PopOver";
// import ErrorIcon from "@material-ui/icons/Error";
// import CheckIcon from "@material-ui/icons/Check";
import EnhancedTable from '../../components/table/EnhancedTable';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import FMPStationMultiSelect from '../../components/pureForm/FMPStationMultiSelect';
import FMPCheckbox from '../../components/pureForm/FMPCheckbox';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import Popover from '@material-ui/core/Popover';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Slide from '@material-ui/core/Slide';
import { green } from '@material-ui/core/colors';
import orange from '@material-ui/core/colors/orange';
import NoteIcon from '@material-ui/icons/Note';
import { getSharedStyles } from '../../themes';
import AuthUserContainer from '../../containers/AuthUser';

const isLocalhost = Boolean(window.location.hostname === 'localhost');
const SlideUpTransition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const styles = (theme) => {
	return {
		...invoiceStatusClassNames,
		...getSharedStyles(theme),
		bigButton: {
			borderRadius: '100px',
			padding: '18px 34px',
			fontSize: 16,
		},
		smallButton: {
			borderRadius: '100px',
			fontWeight: 200,
		},
		pickPlease: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#666',
		},
		divider: {
			borderBottom: '1px dashed #dddddd',
			marginBottom: 25,
			marginTop: 25,
		},
		stats: {
			padding: '20px 10px 20px 10px',
			borderBottom: '1px solid #ddd',
			marginBottom: 10,
		},
		statGroup: {
			padding: '5px 5px 10px 5px',
			borderBottom: '1px solid #eee',
			marginBottom: 10,
		},
		available: {
			fontWeight: 900,
		},
		invoiceDocument: {
			position: 'absolute',
		},
		invoiceDocumentContainer: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
		},
		invoiceIcon: {
			display: 'inline-block',
			width: 40,
			height: 48,
			backgroundImage: `url('${invoiceIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		quickbooksIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${quickbooksLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		row: {
			cursor: 'pointer',
		},
		button: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 5,
			display: 'flex',
			alignItems: 'center',
			fontSize: 16,
			color: '#666',
		},
		dateRange: {
			marginRight: 10,
		},
		icon: {
			marginRight: 5,
		},
		linkedItem: {
			fontSize: 14,
			textDecoration: 'none',
			display: 'flex',
			alignItems: 'center',
		},
		openLink: {
			paddingLeft: 4,
			width: 14,
			height: 14,
		},
		diffError: {
			fontWeight: 900,
			color: '#FF500F',
		},
		contractSub: {
			paddingLeft: 10,
			fontSize: 14,
			color: '#666',
		},
		todo: {
			border: `1px solid #bbb`,
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		addButton: {
			verticalAlign: 'middle',
			textDecoration: 'none',
			marginBottom: 10,
			borderRadius: 100,
		},
		fuelGroup: {
			marginBottom: 7,
		},
		savedSearchHelp: {
			padding: 10,
			color: '#444',
			backgroundColor: '#f7f7f7',
			border: '1px solid #eee',
			marginTop: 5,
			fontWeight: 200,
			marginBottom: 10,
		},
		saveNewSearchSection: {
			//borderTop : '1px solid #d7d7d7',
			marginTop: 20,
			paddingTop: 10,
		},
		noSavedSearches: {
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		savedSearchContainer: {
			marginTop: 10,
			paddingTop: 10,
			borderBottom: '1px solid #d7d7d7',
			marginBottom: 10,
			paddingBottom: 5,
			display: 'flex',
			justifyContent: 'space-between',
		},
		addedOn: {
			fontSize: '85%',
			fontWeight: 200,
			color: '#666',
			paddingTop: 3,
		},
		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),
			fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
		cancelled: {
			color: orange[500],
			fontWeight: 900,
		},
		popOverPaper: {
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
		},
		commentsContainer: {
			padding: 7,
			display: 'inline-block',
			fontSize: '95%',
		},
		commentDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		popover: {
			pointerEvents: 'none',
		},
	};
};

class DeliverySearch extends FormComponent {
	constructor(props) {
		super(props);

		let savedSearches = [];
		if (localStorage.getItem('masterDeliverySaveSearches')) {
			try {
				savedSearches = JSON.parse(localStorage.getItem('masterDeliverySaveSearches'));
			} catch (e) {
				console.error('problems fetching saved searches from local storage', e);
			}
		}

		const dateRange = 'thisMonthUpToEnd';
		const { afterDate, beforeDate } = this.dateRangeToDates(dateRange);
		this.state = {
			formFieldError: {},
			deliveryType: 'all',
			excludeCancelled: false,
			dateRange,
			afterDate,
			beforeDate,
			searchResultRows: undefined,
			order: 'desc',
			orderBy: 'stationInvoiceId',
			isSearching: false,
			savedSearches,
			carrierIds: [],
			pickupTerminalIds: [],
			pickupSupplierIds: [],
			loadingNumber: '',
			stationIds: [],
			bulkCustomerIds: [],
			deliveryTerminalIds: [],
			commentPopoverAnchor: undefined,
			popoverComment: '',
		};
	}

	componentDidMount() {
		//- Only used for updates
		const {
			isExternalLogistics,
			bulkCustomers,
			searchBulkCustomers,
			stations,
			searchStations,
			terminals,
			searchTerminals,
			suppliers,
			searchSuppliers,
			carriers,
			searchCarriers,
		} = this.props;

		if (!isExternalLogistics) {
			if (_.isEmpty(bulkCustomers)) {
				searchBulkCustomers();
			}
		}
		if (isExternalLogistics) {
			this.setState({ deliveryType: 'station' });
		}
		if (_.isEmpty(stations)) {
			searchStations();
		}
		if (_.isEmpty(carriers)) {
			searchCarriers();
		}
		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
		if (_.isEmpty(suppliers)) {
			searchSuppliers();
		}
	}

	getApiParams = () => {
		const { accessToken } = this.props;

		const { afterDate, beforeDate, deliveryType, onlyGmStations, excludeCancelled } = this.state;

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		const params = {
			excludeCancelled,
			accessToken,
			afterDate: afterMoment.format('YYYY-MM-DD'),
			beforeDate: beforeMoment.format('YYYY-MM-DD'),
			deliveryType,
			onlyGmStations,
		};

		[
			'stationIds',
			'bulkCustomerIds',
			'carrierIds',
			'pickupTerminalIds',
			'pickupSupplierIds',
			'loadingNumber',
			'deliveryTerminalIds',
		].forEach((s) => {
			if (this.state[s]) {
				params[`${s}`] = this.state[s];
			}
		});
		return params;
	};

	submitSearch = () => {
		const {
			// advancedSearchDeliveries,
			showErrors,
		} = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const { afterDate, beforeDate } = this.state;

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		if (afterMoment.isAfter(beforeMoment)) {
			formFieldError.afterDate = `Before date can't be before after date. Time is not a circle man.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({
			isSearching: true,
		});

		const params = this.getApiParams();
		post({
			method: 'masterDelivery.search',
			params,
			callback: (err, apiSearchResult) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.formatSearchResults(apiSearchResult);
			},
		});
	};

	formatSearchResults = (apiSearchResult) => {
		const { classes } = this.props;
		const { stationDeliveries, bulkDeliveries, collections } = apiSearchResult;

		const {
			stationInvoiceCollection,
			bulkInvoiceCollection,
			stationCollection,
			carrierCollection,
			supplierCollection,
			terminalCollection,
			bulkCustomerCollection,
			// vendorBillCollection,
		} = collections;

		const stationLookup = _.keyBy(stationCollection, 'stationId');
		// const vendorBillLookup = _.keyBy(vendorBillCollection, 'vendorBillId');
		const carrierLookup = _.keyBy(carrierCollection, 'carrierId');
		const supplierLookup = _.keyBy(supplierCollection, 'supplierId');
		const terminalLookup = _.keyBy(terminalCollection, 'terminalId');
		const stationInvoiceLookup = _.keyBy(stationInvoiceCollection, 'stationInvoiceId');
		const bulkInvoiceLookup = _.keyBy(bulkInvoiceCollection, 'bulkInvoiceId');

		let deliveryInvoiceRows = [];
		stationDeliveries.forEach((stationDelivery) => {
			const row = this.formatStationDelivery({
				stationDelivery,
				stationLookup,
				terminalLookup,
				carrierLookup,
				// supplierLookup,
				stationInvoiceLookup,
				classes,
			});
			deliveryInvoiceRows.push(row);
		});

		const bulkCustomerLookup = _.keyBy(bulkCustomerCollection, 'bulkCustomerId');

		bulkDeliveries.forEach((bulkDelivery) => {
			const row = this.formatBulkDelivery({
				bulkDelivery,
				bulkCustomerLookup,
				terminalLookup,
				carrierLookup,
				supplierLookup,
				bulkInvoiceLookup,
				classes,
			});
			deliveryInvoiceRows.push(row);
		});

		// Default is to include cancelled; when checked exclude them.
		if (this.state.excludeCancelled === true) {
			deliveryInvoiceRows = deliveryInvoiceRows.filter((r) => !r.isCancelled);
		}

		deliveryInvoiceRows = _.orderBy(deliveryInvoiceRows, 'deliveryDateSort');
		this.setState({ deliveryInvoiceRows, isFetchingDeliveries: false });
	};

	handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ snackbarIsOpen: false });
	};

	handleCommentPopoverOpen = (event, internalNote) => {
		this.setState({
			popoverComment: internalNote,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	render() {
		const { classes } = this.props;
		return (
			<Grid container spacing={2}>
				<Grid item md={8} xs={12}>
					{this.renderSearch()}
				</Grid>
				<Grid item md={4} xs={12}>
					{this.renderSaveSearches()}
				</Grid>
				<Grid item md={12} xs={12}>
					{this.renderResults()}
				</Grid>

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					open={this.state.snackbarIsOpen}
					autoHideDuration={2000}
					onClose={this.handleSnackbarClose}
					TransitionComponent={SlideUpTransition}
				>
					<SnackbarContent
						className={classes.snackbarSuccess}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar" className={classes.snackbarMessage}>
								<CheckCircleIcon className={classes.snackbarIcon} />
								<strong>{this.state.snackbarMessage} </strong>
							</span>
						}
						action={[
							<IconButton
								key="close"
								aria-label="close"
								color="inherit"
								onClick={this.handleSnackbarClose}
							>
								<CloseIcon className={classes.icon} />
							</IconButton>,
						]}
					/>
				</Snackbar>

				<Popover
					id="comment-popover"
					className={classes.popover}
					classes={{ paper: classes.popOverPaper }}
					open={!!this.state.commentPopoverAnchor}
					anchorEl={this.state.commentPopoverAnchor}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={this.state.handleCommentPopoverClose}
					disableRestoreFocus
				>
					<div className={classes.commentsContainer}>
						{!!this.state.popoverComment && <div>{this.state.popoverComment}</div>}
					</div>
				</Popover>
			</Grid>
		);
	}

	//- How the saved searches work
	//- Read the cookie on mount that is masterDeliverySaveSearches
	//- This should be an array of hsahes that has all the saved searches
	//- the have will be "name" and state. State will be a copy of certain items in teh state tree

	// Eeach row wll have RUN and trash can. If you hit run it will apply the state and then submit the search
	// At the bottom there will be a button there will bge a section that says "Save New Search"
	// texfield with name. Note field that says "Select the fields you want on the left and hit save"
	// then butotn that says "Save Search"

	saveSearch() {
		const {
			savedSearches,
			savedName,
			deliveryType,
			excludeCancelled,
			carrierIds,
			pickupTerminalIds,
			pickupSupplierIds,
			loadingNumber,
			stationIds,
			bulkCustomerIds,
			deliveryTerminalIds,
			onlyGmStations,
			dateRange,
		} = this.state;

		const {
			// advancedSearchDeliveries,
			showErrors,
		} = this.props;

		const formFieldError = {};

		if (!savedName) {
			formFieldError.savedName = `Do you like chaos?! If you don't name your search then you get chaos.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const newSavedSearches = savedSearches.concat({
			name: savedName,
			dateCreated: moment().format('YYYY-MM-DD HH:mm'),
			savedState: {
				deliveryType,
				excludeCancelled,
				carrierIds,
				pickupTerminalIds,
				pickupSupplierIds,
				loadingNumber,
				deliveryTerminalIds,
				stationIds,
				bulkCustomerIds,
				onlyGmStations,
				dateRange,
			},
		});
		this.setState({ savedSearches: newSavedSearches }, () => {
			localStorage.setItem('masterDeliverySaveSearches', JSON.stringify(newSavedSearches));
		});

		//items to save
	}

	removeSavedSearch(index) {
		const { savedSearches } = this.state;
		const newSavedSearches = savedSearches.slice();
		newSavedSearches.splice(index, 1);
		this.setState({ savedSearches: newSavedSearches }, () => {
			localStorage.setItem('masterDeliverySaveSearches', JSON.stringify(newSavedSearches));
		});
	}

	runSavedSearch(index) {
		const { savedSearches } = this.state;
		const savedSearch = savedSearches[index];
		if (!savedSearch) {
			console.error('Saved search empty', savedSearches);
			return;
		}

		const { savedState } = savedSearch;

		if (savedState.dateRange) {
			const { afterDate, beforeDate } = this.dateRangeToDates(savedState.dateRange);
			if (afterDate) {
				savedState.afterDate = afterDate;
				savedState.beforeDate = beforeDate;
			}
		}

		this.setState(savedState, () => {
			this.submitSearch();
		});
	}

	renderSaveSearches() {
		const { classes } = this.props;
		const { savedSearches } = this.state;
		return (
			<>
				<FMPHeadline label="My Saved Searches" />
				<Paper className={classes.paper}>
					<FMPSectionHeader label="My Saved Searches" isTop={true} />
					<div className={classes.savedSearchHelp}>
						<strong>How to use:</strong> First set the values for all the search fields you want to
						save on the left. Then pick a name for your saved search and hit add. This saved search
						will be available on future visits.
					</div>
					{_.isEmpty(savedSearches) && (
						<div className={classes.noSavedSearches}>No saved searches</div>
					)}

					{savedSearches.map((savedSearch, index) => {
						const { name, dateCreated } = savedSearch;
						return (
							<div className={classes.savedSearchContainer} key={name}>
								<div>
									<div>
										<strong>Name:</strong> {name}
									</div>
									<div className={classes.addedOn}>
										Date Created: {moment(dateCreated).format('MMM D, YYYY')}
									</div>
								</div>
								<div>
									<IconButton
										color="primary"
										onClick={() => {
											this.runSavedSearch(index);
										}}
									>
										<SearchIcon />
									</IconButton>

									<IconButton
										onClick={() => {
											this.removeSavedSearch(index);
										}}
									>
										<DeleteIcon />
									</IconButton>
								</div>
							</div>
						);
					})}

					<div className={classes.saveNewSearchSection}>
						<FMPText {...this.setForm('savedName', 'Name of saved search', false)} />

						<Button
							variant={'outlined'}
							color="primary"
							onClick={() => {
								this.saveSearch();
							}}
						>
							Save Search
						</Button>
					</div>
				</Paper>
			</>
		);
	}

	renderSearch() {
		const { isExternalLogistics, classes } = this.props;
		const { deliveryType, stationFormatErrors } = this.state;

		return (
			<>
				<FMPHeadline label="Master Delivery Search" />
				<Paper className={classes.paper}>
					<Grid container spacing={2}>
						{!isExternalLogistics && (
							<FMPSelect
								{...this.setForm('deliveryType', 'Deliveries to search', true)}
								options={[
									{ value: 'all', display: 'All Deliveries' },
									{ value: 'station', display: 'Only Station Deliveries' },
									{ value: 'bulk', display: 'Only Bulk Deliveries' },
								]}
							/>
						)}

						<div className={classes.divider} />
						{deliveryType === 'station' && this.renderStationSearchOptions()}
						{deliveryType === 'bulk' && this.renderBulkSearchOptions()}
						{this.renderAllSearchOptions()}
						{this.renderSubmitButtons()}
					</Grid>
				</Paper>

				{!_.isEmpty(stationFormatErrors) && this.renderErrors(stationFormatErrors)}
			</>
		);
	}

	renderResults() {
		const { isExternalLogistics, classes } = this.props;
		const { deliveryInvoiceRows } = this.state;

		const colStyle = {
			whiteSpace: 'nowrap',
			padding: '3px 4px',
			overflow: 'hidden',
			verticalAlign: 'middle',
			fontFamily: 'arial,sans,sans-serif',
			textAlign: 'right',
			border: '1px solid rgb(204,204,204)',
			backgroundColor: '#f7f7f7',
		};

		let showType = false;
		if (!_.isEmpty(deliveryInvoiceRows)) {
			const grouped = _.groupBy(deliveryInvoiceRows, 'deliveryType');
			showType = _.keys(grouped).length > 1;
		}

		const deliveryInvoiceColumns = [
			{
				sortId: 'deliveryDateSort',
				displayId: 'deliveryDateDisplay',
				label: 'Date',
			},
			{
				sortId: 'type',
				displayId: 'typeAndProduct',
				labels: ['Type', 'Product'],
			},
			{
				sortId: 'key',
				displayId: 'deliveryDisplay',
				label: 'Delivery Info',
			},
			{
				sortId: 'totalDeliveryAmount',
				displayId: 'deliveryVolumes',
				label: 'Scheduled Volumes',
			},
		];

		if (!isExternalLogistics) {
			deliveryInvoiceColumns.push(
				{
					/*
				sortId: 'carrier',
				displayId : 'carrierDisplay',
				label : 'Carrier',
			}, {
				 */
					sortId: 'invoiceId',
					displayId: 'invoiceDisplay',
					label: 'Invoice Info',
				},
				{
					sortId: 'productType',
					displayId: 'invoiceVolumes',
					label: 'Invoiced (net) Volumes',
				},
				{
					/*
				sortId: 'totalDeliveryAmount',
				displayId : 'bothVolumes',
				labels: ['Scheduled Volumes', 'Invoiced (net) Volumes'],
			}, {
				*/
					sortId: 'totalDiff',
					displayId: 'diffDisplay',
					label: 'Volume Diff',
				}
			);
		}

		deliveryInvoiceColumns.push({
			sortId: 'internalNote',
			displayId: 'commentDisplay',
			label: 'Internal Note',
		});

		return (
			<Paper className={classes.paper} style={{ marginTop: 20 }}>
				{_.isEmpty(deliveryInvoiceRows) && <div className={classes.resultsHere}>Results here</div>}
				{!_.isEmpty(deliveryInvoiceRows) && (
					<>
						{!isExternalLogistics && (
							<Button variant="contained" color="primary" onClick={this.copyTableToClipboard}>
								Copy {deliveryInvoiceRows.length} rows to clipboard
							</Button>
						)}

						<EnhancedTable
							isDense={true}
							columns={deliveryInvoiceColumns}
							rows={deliveryInvoiceRows}
							defaultOrder={'desc'}
							defaultOrderBy={'deliveryDateSort'}
						/>

						<table
							id="tableForCopy"
							cellSpacing="0"
							cellPadding="0"
							dir="ltr"
							border="1"
							style={{
								display: 'none',
								tableLayout: 'fixed',
								fontSize: '14px',
								fontFamily: 'arial,sans,sans-serif',
								borderCollapse: 'collapse',
							}}
						>
							<thead>
								<tr>
									<td style={colStyle}>Delivery Window Date</td>
									<td style={colStyle}>Delivery Window Time</td>
									{showType && <td style={colStyle}>Type</td>}
									<td style={colStyle}>Delivery #</td>
									<td style={colStyle}>Customer(s)</td>
									<td style={colStyle}>Carrier</td>
									<td style={colStyle}>Fuel</td>
									<td style={colStyle}>Volume</td>
									<td style={colStyle}>Status</td>
								</tr>
							</thead>
							<tbody>
								{deliveryInvoiceRows.map((row, index) => {
									const {
										deliveryId,
										deliveryWindowDate,
										deliveryWindowTime,
										deliveryType,
										deliveryDisplayForCopy,
										carrierDisplay,
										totalDeliveryAmount,
										productType,
										isCancelled,
									} = row;
									const status = isCancelled ? 'CANCELLED' : 'Good';
									const tdStyle = {
										whiteSpace: 'nowrap',
										padding: '3px 4px',
										overflow: 'hidden',
										verticalAlign: 'middle',
										fontFamily: 'arial,sans,sans-serif',
										textAlign: 'right',
										border: '1px solid rgb(204,204,204)',
									};
									return (
										<tr key={index}>
											<td style={tdStyle}>{deliveryWindowDate}</td>
											<td style={tdStyle}>{deliveryWindowTime}</td>
											{showType && <td style={tdStyle}>{deliveryType}</td>}
											<td style={tdStyle}>{deliveryId}</td>
											<td style={tdStyle}>{deliveryDisplayForCopy}</td>
											<td style={tdStyle}>{carrierDisplay}</td>
											<td style={tdStyle}>{productType.toUpperCase()}</td>
											<td style={tdStyle}>{totalDeliveryAmount}</td>
											<td style={tdStyle}>{status}</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</>
				)}
			</Paper>
		);
	}

	copyTableToClipboard = () => {
		this.copyElementToClipboard('tableForCopy');
	};
	copyElementToClipboard = (elementId) => {
		const text = document.getElementById(elementId);
		text.style.display = 'table';
		let range;
		let selection;

		if (document.body.createTextRange) {
			range = document.body.createTextRange();
			range.moveToElementText(text);
			range.select();
		} else if (window.getSelection) {
			selection = window.getSelection();
			range = document.createRange();
			range.selectNodeContents(text);
			selection.removeAllRanges();
			selection.addRange(range);
		}
		document.execCommand('copy');
		window.getSelection().removeAllRanges();
		text.style.display = 'none';
		// document.getElementById("btn").value="Copied";

		const { deliveryInvoiceRows } = this.state;
		this.setState({
			snackbarMessage: `Copied ${deliveryInvoiceRows.length} rows to the clipboard`,
			snackbarIsOpen: true,
		});
	};

	setDateRange = (dateRange) => {
		const { afterDate, beforeDate } = this.dateRangeToDates(dateRange);
		if (!afterDate) {
			this.setState({ dateRange });
		} else {
			this.setState({ dateRange, afterDate, beforeDate });
		}
	};

	dateRangeToDates = (dateRange) => {
		if (dateRange === 'today') {
			return {
				afterDate: moment().format('YYYY-MM-DD'),
				beforeDate: moment().format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'todayTo30DaysOut') {
			return {
				afterDate: moment().format('YYYY-MM-DD'),
				beforeDate: moment().add(30, 'days').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'thisMonthUpToToday') {
			return {
				afterDate: moment().startOf('month').format('YYYY-MM-DD'),
				beforeDate: moment().format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'thisMonthUpToEnd') {
			return {
				afterDate: moment().startOf('month').format('YYYY-MM-DD'),
				beforeDate: moment().endOf('month').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'last7Days') {
			return {
				afterDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
				beforeDate: moment().format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'next7Days') {
			return {
				afterDate: moment().format('YYYY-MM-DD'),
				beforeDate: moment().add(7, 'days').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'lastMonth') {
			return {
				afterDate: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
				beforeDate: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
			};
		} else {
			return {};
		}
	};

	/*
	componentDidUpdate(prevProps, prevState) {
		if (this.state.dateRange !== prevState.dateRange) {
			if (this.state.dateRange === 'today') {
				this.setState({
					afterDate: moment().format('YYYY-MM-DD'),
					beforeDate: moment().format('YYYY-MM-DD'),
				});
			} else if (this.state.dateRange === 'todayTo30DaysOut') {
				this.setState({
					afterDate: moment().format('YYYY-MM-DD'),
					beforeDate: moment().add(30, 'days').format('YYYY-MM-DD'),
				});
			} else if (this.state.dateRange === 'thisMonthUpToToday') {
				this.setState({
					afterDate: moment().startOf('month').format('YYYY-MM-DD'),
					beforeDate: moment().format('YYYY-MM-DD'),
				});
			} else if (this.state.dateRange === 'thisMonthUpToEnd') {
				this.setState({
					afterDate: moment().startOf('month').format('YYYY-MM-DD'),
					beforeDate: moment().endOf('month').format('YYYY-MM-DD'),
				});
			} else if (this.state.dateRange === 'last7Days') {
				this.setState({
					afterDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
					beforeDate: moment().format('YYYY-MM-DD'),
				});
			} else if (this.state.dateRange === 'next7Days') {
				this.setState({
					afterDate: moment().format('YYYY-MM-DD'),
					beforeDate: moment().add(7, 'days').format('YYYY-MM-DD'),
				});
			} else if (this.state.dateRange === 'lastMonth') {
				this.setState({
					afterDate: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
					beforeDate: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
				});
			}
		}
	}
	*/

	renderDateButton = (label, range) => {
		const { classes } = this.props;
		const { dateRange } = this.state;

		const variant = dateRange === range ? 'contained' : 'outlined';

		return (
			<Button
				className={classes.dateRange}
				variant={variant}
				color="primary"
				onClick={() => {
					this.setDateRange(range);
				}}
			>
				{label}
			</Button>
		);
	};
	renderDateRangeOptions = () => {
		const { isExternalLogistics } = this.props;

		const { dateRange } = this.state;
		let disabled = true;
		if (dateRange === 'custom') {
			disabled = false;
		}

		return (
			<>
				<Grid item md={12}>
					<FMPSectionHeader label={'Date Range'} />
				</Grid>

				{!isExternalLogistics && (
					<Grid item md={12} style={{ display: 'flex' }}>
						{this.renderDateButton('Today', 'today')}
						{this.renderDateButton('Today to 30 days out', 'todayTo30DaysOut')}
						{this.renderDateButton('This Month Up To Today', 'thisMonthUpToToday')}
						{this.renderDateButton('This Month To End', 'thisMonthUpToEnd')}
						{this.renderDateButton('Last Month', 'lastMonth')}
						{this.renderDateButton('Last 7 days', 'last7Days')}
						{this.renderDateButton('Custom', 'custom')}
					</Grid>
				)}

				{isExternalLogistics && (
					<Grid item md={12} style={{ display: 'flex' }}>
						{this.renderDateButton('Today', 'today')}
						{this.renderDateButton('Last 7 days', 'last7Days')}
						{this.renderDateButton('Next 7 days', 'next7Days')}
					</Grid>
				)}

				<FMPDatePicker
					{...this.setForm('afterDate', 'Delivery Date After', true)}
					format={'MMMM Do, YYYY'}
					md={5}
					disabled={disabled}
				/>

				<FMPDatePicker
					{...this.setForm('beforeDate', 'Delivery Date Before', true)}
					format={'MMMM Do, YYYY'}
					md={5}
					disabled={disabled}
				/>
			</>
		);
	};

	renderSubmitButtons = () => {
		const { isExternalLogistics, classes } = this.props;
		const { isSearching } = this.state;

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'masterDelivery.search',
			params,
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}
		const downloadUrl = `${host}/api?request=${JSON.stringify(request)}`;

		return (
			<Grid container spacing={2}>
				<Grid item md={12} style={{ paddingTop: 25, display: 'flex' }}>
					<Button
						className={classes.bigButton}
						variant="contained"
						color="primary"
						onClick={this.submitSearch}
						disabled={isSearching}
					>
						<Search className={classes.icon} />
						Delivery Search
					</Button>

					{!isExternalLogistics && (
						<a
							href={downloadUrl}
							style={{ textDecoration: 'none', paddingRight: 5 }}
							target="_blank"
							rel="noreferrer noopener"
						>
							<Button
								className={classes.bigButton}
								variant="contained"
								color="primary"
								style={{ marginLeft: 10 }}
								disabled={isSearching}
							>
								<DownloadIcon className={classes.icon} />
								Search & Download
							</Button>
						</a>
					)}

					{isSearching && (
						<div className={classes.runningSearch}>
							<CircularProgress />
							<span style={{ paddingLeft: 5 }}>Searching...</span>
						</div>
					)}
				</Grid>
			</Grid>
		);
	};

	renderAllSearchOptions = () => {
		const { carriers, terminals, suppliers } = this.props;

		return (
			<>
				{this.renderDateRangeOptions()}

				<Grid item xs={12}>
					<FMPSectionHeader label={'Options'} />
				</Grid>

				<FMPCheckbox
					{...this.setForm('excludeCancelled', 'Exclude canceled orders', false, false)}
				/>

				<FMPCarrierMultiSelect
					{...this.setForm('carrierIds', 'Carriers', false, [])}
					carriers={carriers}
				/>

				<FMPTerminalMultiSelect
					{...this.setForm('pickupTerminalIds', 'Pickup Terminals', false, [])}
					terminals={terminals}
					productTypes={['e85', 'etoh', 'unl']}
				/>

				<FMPSupplierMultiSelect
					{...this.setForm('pickupSupplierIds', 'Pickup Suppliers', false, [])}
					suppliers={suppliers}
				/>

				<FMPText {...this.setForm('loadingNumber', 'Loading Number')} />
			</>
		);
	};

	renderStationSearchOptions = () => {
		const { stations } = this.props;

		return (
			<>
				<Grid item xs={12}>
					<FMPSectionHeader label={'Station Delivery Options'} />
				</Grid>

				<FMPStationMultiSelect
					{...this.setForm('stationIds', 'Delivered to Stations', false, [])}
					stations={stations}
					disabled={this.state.onlyGmStations}
				/>

				<FMPCheckbox
					{...this.setForm('onlyGmStations', 'Only Use All G&M Stations', false, false)}
				/>
			</>
		);
	};

	renderBulkSearchOptions = () => {
		const { bulkCustomers, terminals } = this.props;
		return (
			<>
				<Grid item xs={12}>
					<FMPSectionHeader label={'Bulk Delivery Options'} />
				</Grid>

				<FMPBulkCustomerMultiSelect
					{...this.setForm('bulkCustomerIds', 'Bulk Customers', false, [])}
					bulkCustomers={bulkCustomers}
				/>

				<FMPTerminalMultiSelect
					{...this.setForm('deliveryTerminalIds', 'Delivery Terminals', false, [])}
					terminals={terminals}
					productTypes={['e85', 'etoh', 'unl']}
				/>
			</>
		);
	};

	formatStationDelivery = (p) => {
		const {
			stationDelivery,
			stationLookup,
			terminalLookup,
			//supplierLookup,
			carrierLookup,
			stationInvoiceLookup,
			classes,
		} = p;

		const errors = [];

		const {
			stationDeliveryId,
			primaryProductType,
			primaryStationId,
			primaryDeliveryAmount,
			carrierId,
			deliveryWindowStartDateTime,
			isCancelled,
			internalNote,
		} = stationDelivery;

		//- Format the delivery — one line per stop
		const legs = getDeliveryLegs(stationDelivery);
		const stations = [];
		const primaryStation = stationLookup[primaryStationId] || { number: '?', name: 'Missing' };
		let totalDeliveryAmount = primaryDeliveryAmount;
		let primaryStationDisplay = `${primaryStation.number} - ${primaryStation.name}`;
		if (legs.length > 1) {
			primaryStationDisplay += ` (${primaryDeliveryAmount})`;
		}
		stations.push(primaryStationDisplay);

		legs
			.filter((leg) => leg.legNumber >= 2)
			.forEach((leg) => {
				const station = stationLookup[leg.stationId] || {
					number: '?',
					name: 'Missing',
				};
				stations.push(`${station.number} - ${station.name} (${leg.deliveryAmount})`);
				totalDeliveryAmount += leg.deliveryAmount || 0;
			});

		const dateDisplay = moment(deliveryWindowStartDateTime).format('ddd, M/D');
		const carrier = carrierLookup[carrierId] || { name: 'Missing' };
		const deliveryDisplay = (
			<Fragment>
				<div>
					<a
						href={`/logistics/stationDelivery/update/${stationDeliveryId}`}
						className={classes.linkedItem}
						target="_blank"
						rel="noreferrer noopener"
					>
						<span>Delivery #{stationDeliveryId}</span> <OpenLink className={classes.openLink} />
					</a>
				</div>
				{stations.map((st, i) => {
					return <div key={i}>{st}</div>;
				})}
				<div>{carrier.name}</div>
				{isCancelled && <div className={classes.cancelled}>CANCELLED</div>}
			</Fragment>
		);

		const deliveryDisplayForCopy = (
			<>
				{stations.map((st, i) => {
					return <div key={i}>{st}</div>;
				})}
			</>
		);

		let commentDisplay;
		if (!internalNote) {
			commentDisplay = <div>-</div>;
		} else {
			commentDisplay = (
				<div
					style={{ display: 'inline-block', color: '#2196f3' }}
					onMouseEnter={(event) => {
						this.handleCommentPopoverOpen(event, internalNote);
					}}
					onMouseLeave={this.handleCommentPopoverClose}
				>
					<NoteIcon />
				</div>
			);
		}

		const { deliveryWindowDate, deliveryWindowTime } = formatDeliveryWindow({ stationDelivery });
		const primaryProductTypeDisplay = valueToDisplay(primaryProductType);
		const row = {
			deliveryType: 'Station',
			deliveryId: stationDeliveryId,
			key: stationDeliveryId,
			type: 'stationDelivery',
			typeAndProduct: (
				<div>
					<div>Station Delivery</div>
					<div>{primaryProductTypeDisplay}</div>
				</div>
			),
			carrierDisplay: carrier.name,
			deliveryWindowDate,
			deliveryWindowTime,
			deliveryDateSort: deliveryWindowStartDateTime,
			deliveryDateDisplay: dateDisplay,
			deliveryDisplayForCopy,
			productType: primaryProductType,
			primaryProductType,
			deliveryDisplay,
			totalDeliveryAmount,
			isCancelled,
			commentDisplay,
		};

		const {
			firstTerminalProductType,
			firstTerminalFuelToPickupTotal,
			secondTerminalProductType,
			secondTerminalFuelToPickupTotal,
		} = stationDelivery;

		const deliveryVolumes = [
			{
				productType: firstTerminalProductType,
				total: firstTerminalFuelToPickupTotal,
			},
		];

		if (secondTerminalProductType && secondTerminalFuelToPickupTotal) {
			deliveryVolumes.push({
				productType: secondTerminalProductType,
				total: secondTerminalFuelToPickupTotal,
			});
		}

		const deliveryVolumesByProduct = {};
		row.deliveryVolumes = _.sortBy(deliveryVolumes, 'productType').map((deliveryVolume) => {
			const { productType, total } = deliveryVolume;
			deliveryVolumesByProduct[productType] = total;
			return (
				<div key={productType}>
					<span>{valueToDisplay(productType)} :</span>
					<span>{total}</span>
				</div>
			);
		});

		//- Match up invoice
		const { linkedToStationInvoiceIds } = stationDelivery;

		//- Don't have any invoices yet
		if (_.isEmpty(linkedToStationInvoiceIds)) {
			row.invoiceId = null;
			row.invoiceDisplay = 'No invoice yet';
			row.invoiceVolumes = 'No Invoice';
			row.diffDisplay = 'n/a';
			row.bothVolumes = (
				<>
					<div className={classes.fuelGroup}>{row.deliveryVolumes}</div>
					<div className={classes.fuelGroup}>{row.invoiceVolumes}</div>
				</>
			);
			return row;
		}

		const invoiceVolumeByType = {};
		const invoiceDisplays = [];
		linkedToStationInvoiceIds.forEach((stationInvoiceId) => {
			const stationInvoice = stationInvoiceLookup[stationInvoiceId];
			if (!stationInvoice) {
				errors.push(`Missing station invoice: ${stationInvoiceId}`);
				return;
			}

			const { products } = stationInvoice;

			//- InvoiceInfo
			const invoiceLines = [];
			if (_.isEmpty(products)) {
				invoiceLines.push('No fuels yet');
			} else {
				products.forEach((product) => {
					const { productType, terminalSupplier, netGallons } = product;
					let terminalDisplay = 'No terminal yet';
					if (terminalSupplier) {
						const terminal = terminalLookup[terminalSupplier.terminalId] || {
							name: `Missing terminal : ${terminalSupplier.terminalId}`,
						};
						terminalDisplay = terminal.name;
					}
					if (!invoiceVolumeByType[productType]) {
						invoiceVolumeByType[productType] = 0;
					}
					invoiceVolumeByType[productType] += netGallons;
					invoiceLines.push(`${netGallons} ${productType} : ${terminalDisplay}`);
				});
			}

			invoiceDisplays.push(
				<div key={stationInvoiceId}>
					<div>
						<a
							href={`/accounting/stationInvoice/update/${stationInvoiceId}`}
							className={classes.linkedItem}
							target="_blank"
							rel="noreferrer noopener"
						>
							<span>Invoice #{stationInvoiceId}</span> <OpenLink className={classes.openLink} />
						</a>
					</div>
					<div style={{ paddingLeft: 10 }}>
						{invoiceLines.map((invoiceLine, i) => {
							return <div key={`il_${i}`}>{invoiceLine}</div>;
						})}
					</div>
				</div>
			);
		});

		const diffs = [];
		row.invoiceVolumes = _.keys(invoiceVolumeByType)
			.sort()
			.map((productType) => {
				const deliveryTotal = deliveryVolumesByProduct[productType];
				const total = invoiceVolumeByType[productType];
				if (deliveryTotal) {
					const diffTotal = deliveryTotal - total;
					diffs.push({
						productType,
						diffTotal,
						status: Math.abs(diffTotal) > 200 ? 'diffError' : 'diffNormal',
					});
				}

				return (
					<div key={productType}>
						<span>{valueToDisplay(productType)} :</span>
						<span>{total}</span>
					</div>
				);
			});

		row.invoiceDisplay = (
			<Fragment>
				{invoiceDisplays.map((invoiceDisplay) => {
					return invoiceDisplay;
				})}
			</Fragment>
		);

		row.bothVolumes = (
			<>
				<div className={classes.fuelGroup}>{row.deliveryVolumes}</div>
				<div className={classes.fuelGroup}>{row.invoiceVolumes}</div>
			</>
		);

		let totalDiff = 0;
		row.diffDisplay = diffs.map((diff) => {
			const { productType, diffTotal, status } = diff;
			totalDiff += diffTotal;
			return (
				<div key={productType}>
					<span>{valueToDisplay(productType)} :</span>
					<span className={classes[status]}>{diffTotal}</span>
				</div>
			);
		});
		row.totalDiff = totalDiff;
		return row;
	};

	formatBulkDelivery = (p) => {
		const {
			bulkDelivery,
			bulkCustomerLookup,
			terminalLookup,
			carrierLookup,
			//supplierLookup,
			bulkInvoiceLookup,
			classes,
		} = p;

		const {
			bulkDeliveryId,
			deliveryBulkCustomerId,
			productType,
			// deliveryTerminalId,
			// pickupTerminalId,
			// pickupSupplierId,
			deliveryDate,
			carrierId,
			isCancelled,
			internalNote,
		} = bulkDelivery;

		const bulkCustomer = bulkCustomerLookup[deliveryBulkCustomerId] || { name: 'Missing' };
		const bulkCustomerDisplay = bulkCustomer.name;

		//- Delivery
		const dateDisplay = moment(deliveryDate).format('ddd, M/D');
		const carrier = carrierLookup[carrierId] || { name: 'Missing' };
		const deliveryDisplay = (
			<Fragment>
				<div>
					<a
						href={`/logistics/bulkDelivery/update/${bulkDeliveryId}`}
						className={classes.linkedItem}
						target="_blank"
						rel="noreferrer noopener"
					>
						<span>Delivery #{bulkDeliveryId}</span> <OpenLink className={classes.openLink} />
					</a>
				</div>
				<div>{bulkCustomerDisplay}</div>
				<div>{carrier.name}</div>
				{isCancelled && <div className={classes.cancelled}>CANCELLED</div>}
			</Fragment>
		);

		const deliveryDisplayForCopy = bulkCustomerDisplay;
		const totalDeliveryAmount = 8000;
		const productTypeDisplay = valueToDisplay(productType);

		let commentDisplay;
		if (!internalNote) {
			commentDisplay = <div>-</div>;
		} else {
			commentDisplay = (
				<div
					style={{ display: 'inline-block', color: '#2196f3' }}
					onMouseEnter={(event) => {
						this.handleCommentPopoverOpen(event, internalNote);
					}}
					onMouseLeave={this.handleCommentPopoverClose}
				>
					<NoteIcon />
				</div>
			);
		}

		const { deliveryWindowDate, deliveryWindowTime } = formatDeliveryWindow({ bulkDelivery });
		const row = {
			deliveryType: 'Bulk',
			deliveryId: bulkDeliveryId,
			key: bulkDeliveryId,
			type: 'bulkDelivery',
			typeAndProduct: (
				<div>
					<div>Bulk Delivery</div>
					<div>{productTypeDisplay}</div>
				</div>
			),
			carrierDisplay: carrier.name,
			deliveryWindowDate,
			deliveryWindowTime,
			deliveryDateSort: deliveryDate,
			deliveryDateDisplay: dateDisplay,
			deliveryDisplayForCopy,
			productType,
			deliveryDisplay,
			totalDeliveryAmount,
			allocatedGallons: totalDeliveryAmount,
			isCancelled,
			commentDisplay,
		};

		const deliveryVolumes = [
			{
				productType,
				total: totalDeliveryAmount,
			},
		];

		const deliveryVolumesByProduct = {};
		row.deliveryVolumes = _.sortBy(deliveryVolumes, 'productType').map((deliveryVolume) => {
			const { productType, total } = deliveryVolume;
			deliveryVolumesByProduct[productType] = total;
			return (
				<div key={productType}>
					<span>{valueToDisplay(productType)} :</span>
					<span>{total}</span>
				</div>
			);
		});

		const { linkedToBulkInvoiceIds } = bulkDelivery;

		//- Match up invoice
		//- Don't have any invoices yet

		setupBulkInvoiceDisplay({
			row,
			linkedToBulkInvoiceIds,
			bulkInvoiceLookup,
			terminalLookup,
			bulkDelivery,
			carrier,
			classes,
			deliveryVolumesByProduct,
		});
		return row;
	};
}

function formatDeliveryWindow({ stationDelivery, bulkDelivery }) {
	if (bulkDelivery) {
		const { deliveryDate } = bulkDelivery;
		return {
			deliveryWindowDate: `${moment(deliveryDate).format('M/D/YY')}`,
			deliveryWindowTime: `All Day`,
		};
	}

	const { deliveryWindowStartDateTime, deliveryWindowEndDateTime, allDayWindow } = stationDelivery;
	const start = moment(deliveryWindowStartDateTime);
	const end = moment(deliveryWindowEndDateTime);

	if (allDayWindow) {
		return {
			deliveryWindowDate: `${start.format('M/D/YY')}`,
			deliveryWindowTime: 'All Day',
		};
	} else if (start.date() === end.date()) {
		const firstTime = start.minute() === 0 ? start.format('h') : start.format('h:mm');

		const secondTime = end.minute() === 0 ? end.format('h') : end.format('h:mm');

		let time;
		const sampm = start.format('a');
		const eampm = end.format('a');

		if (sampm === eampm) {
			time = `(${firstTime} - ${secondTime} ${sampm})`;
		} else {
			time = `(${firstTime} ${sampm} - ${secondTime} ${eampm})`;
		}

		return {
			deliveryWindowDate: `${start.format('M/D/YY')}`,
			deliveryWindowTime: time,
		};
	} else {
		return {
			deliveryWindowDate: `${start.format('M/D/YY')} - ${end.format('M/D/YY')}`,
			deliveryWindowTime: `${start.format('h:mm a')} - ${end.format('h:mm a')}`,
		};
	}
}

const RTC_FUELS_BULK_CUSTOMER_ID = 10;

function setupBulkInvoiceDisplay(p) {
	const {
		row,
		linkedToBulkInvoiceIds,
		bulkInvoiceLookup,
		terminalLookup,
		bulkDelivery,
		carrier,
		classes,
		deliveryVolumesByProduct,
	} = p;

	const { deliveryBulkCustomerId, productType } = bulkDelivery;

	if (_.isEmpty(linkedToBulkInvoiceIds)) {
		if (deliveryBulkCustomerId === RTC_FUELS_BULK_CUSTOMER_ID) {
			row.invoiceId = null;
			row.invoiceDisplay = 'none (RTC Fuels)';
			row.invoiceVolumes = 'none (RTC Fuels)';
			row.diffDisplay = '-';
		} else {
			row.invoiceId = null;
			row.invoiceDisplay = 'No invoice yet';
			row.invoiceVolumes = 'No Invoice';
			row.diffDisplay = 'n/a';
		}
		return;
	}

	const invoiceVolumeByType = {};
	const invoiceDisplays = [];
	linkedToBulkInvoiceIds.forEach((bulkInvoiceId) => {
		const bulkInvoice = bulkInvoiceLookup[bulkInvoiceId];

		const {
			pickupTerminalId,
			offloadTerminalId,
			pickupNetGallons,
			offloadNetGallons,
		} = bulkInvoice;

		let fuelInfo;
		if (pickupNetGallons && offloadNetGallons) {
			invoiceVolumeByType[productType] = pickupNetGallons;
			const pickupTerminal = terminalLookup[pickupTerminalId] || { name: `Missing terminal` };
			const offloadTerminal = terminalLookup[offloadTerminalId] || { name: `Missing terminal` };
			fuelInfo = (
				<Fragment>
					<div>{carrier.name}</div>
					<div>
						Pickup : {pickupNetGallons} from {pickupTerminal.name}
					</div>
					<div>
						Offload : {offloadNetGallons} to {offloadTerminal.name}
					</div>
				</Fragment>
			);
		} else {
			fuelInfo = (
				<Fragment>
					<div>No documents yet</div>
				</Fragment>
			);
		}

		invoiceDisplays.push(
			<div key={bulkInvoiceId}>
				<div>
					<a
						href={`/accounting/bulkInvoice/update/${bulkInvoiceId}`}
						className={classes.linkedItem}
						target="_blank"
						rel="noreferrer noopener"
					>
						<span>Invoice #{bulkInvoiceId}</span> <OpenLink className={classes.openLink} />
					</a>
				</div>
				<div style={{ paddingLeft: 10 }}>{fuelInfo}</div>
			</div>
		);
	});

	row.invoiceDisplay = (
		<Fragment>
			{invoiceDisplays.map((invoiceDisplay) => {
				return invoiceDisplay;
			})}
		</Fragment>
	);

	if (_.isEmpty(_.keys(invoiceVolumeByType))) {
		row.invoiceVolumes = 'n/a';
		row.diffDisplay = 'n/a';
		return;
	}

	const diffs = [];
	row.invoiceVolumes = _.keys(invoiceVolumeByType)
		.sort()
		.map((productType) => {
			const deliveryTotal = deliveryVolumesByProduct[productType];
			const total = invoiceVolumeByType[productType];
			if (deliveryTotal) {
				const diffTotal = deliveryTotal - total;
				diffs.push({
					productType,
					diffTotal,
					status: Math.abs(diffTotal) > 300 ? 'diffError' : 'diffNormal',
				});
			}

			return (
				<div key={productType}>
					<span>{valueToDisplay(productType)} :</span>
					<span>{total}</span>
				</div>
			);
		});

	let totalDiff = 0;
	row.diffDisplay = diffs.map((diff) => {
		const { productType, diffTotal, status } = diff;
		totalDiff += diffTotal;
		return (
			<div key={productType}>
				<span>{valueToDisplay(productType)} :</span>
				<span className={classes[status]}>{diffTotal}</span>
			</div>
		);
	});
	row.totalDiff = totalDiff;
}

DeliverySearch.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object,
	canMakeUpdates: PropTypes.bool,

	bulkCustomers: PropTypes.array,
	searchBulkCustomers: PropTypes.func.isRequired,

	advancedSearchStationInvoices: PropTypes.func.isRequired,
	advancedSearchBulkInvoices: PropTypes.func.isRequired,

	stations: PropTypes.array,
	searchStations: PropTypes.func.isRequired,

	carriers: PropTypes.array,
	searchCarriers: PropTypes.func.isRequired,

	terminals: PropTypes.array,
	searchTerminals: PropTypes.func.isRequired,

	suppliers: PropTypes.array,
	searchSuppliers: PropTypes.func.isRequired,

	accessToken: PropTypes.string,

	stationMap: PropTypes.object,
	carrierMap: PropTypes.object,
	invoiceDocumentMap: PropTypes.object,
	stationDeliveryMap: PropTypes.object,
	terminalMap: PropTypes.object,
	supplierMap: PropTypes.object,
	bulkCustomerMap: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,
	resourceMap: PropTypes.object,

	isExternalLogistics: PropTypes.bool.isRequired,
};

export default _.flow([
	withStyles(styles),
	StationInvoicesContainer,
	BulkInvoicesContainer,
	BulkCustomersContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
	SuppliersContainer,
	AuthUserContainer,
])(DeliverySearch);
